import { ScenarioStatus, StatusIndicator } from '@/types/scenario.types';
import { CustomerCaseStatus } from '@/api/apis/case';

export const CUSTOMER_CASE_STATUS_SCENARIO: Record<ScenarioStatus, CustomerCaseStatus[]> = {
  [ScenarioStatus.Positive]: [
    CustomerCaseStatus.CaseInitiatedForOCS,
    CustomerCaseStatus.OrganOffOCS,
    CustomerCaseStatus.NOPServiceCompleted,
  ],
  [ScenarioStatus.Negative]: [
    CustomerCaseStatus.CaseDeclined,
    CustomerCaseStatus.LogisticsQuoteDeclined,
    CustomerCaseStatus.CaseCanceled,
    CustomerCaseStatus.TransplantNotCompleted,
    CustomerCaseStatus.ServiceRejectedByTxc,
  ],
  [ScenarioStatus.Neutral]: [
    CustomerCaseStatus.Draft,
    CustomerCaseStatus.UnderClinicalScreening,
    CustomerCaseStatus.LogisticsQuoteReceived,
    CustomerCaseStatus.TeamDeploymentInProgress,
    CustomerCaseStatus.AtDonorHospital,
    CustomerCaseStatus.OrganOnOCS,
    CustomerCaseStatus.OrganInTransit,
    CustomerCaseStatus.OrganAtTXCenter,
    CustomerCaseStatus.NOPInvoiceReceived,
  ],
};

export const CUSTOMER_CASE_STATUS_DOT_INDICATOR: Record<StatusIndicator, CustomerCaseStatus[]> = {
  [StatusIndicator.Danger]: [CustomerCaseStatus.LogisticsQuoteRecalled],
};

export enum CustomCustomerCaseStatus {
  OrganOnSCS = 'OrganOnSCS',
  OrganOffSCS = 'OrganOffSCS',
}
